import { Component, inject, output, signal } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DeaktivierungsGrundAdminCmd } from '@app/shared/classes/deaktivierungs-grund';
import { BackendService } from '@app/shared/services/backend.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-admin-stammdaten-deaktivierungsgrund-new',
  templateUrl: './admin-stammdaten-deaktivierungsgrund-new.component.html',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
  ],
})
export class AdminStammdatenDeaktivierungsgrundNewComponent {
  private readonly backendService = inject(BackendService);
  private readonly translateService = inject(TranslateService);
  private readonly formBuilder = inject(UntypedFormBuilder);

  readonly reloadEntries = output();

  protected readonly newGrundForm = signal(this.generateForm());

  private generateForm(): UntypedFormGroup {
    return this.formBuilder.group({
      sortierung_new    : ['', [Validators.pattern('^[0-9]*$'), Validators.required]],
      bezeichnungDe_new : ['', Validators.required],
      bezeichnungFr_new : ['', Validators.required],
      bezeichnungIt_new : ['', Validators.required],
      textDe_new        : ['', Validators.required],
      textFr_new        : ['', Validators.required],
      textIt_new        : ['', Validators.required]
    });
  }

  protected submit() {
    const formValues = this.newGrundForm().value;
    const grund = new DeaktivierungsGrundAdminCmd({
      sortierung    : formValues.sortierung_new,
      bezeichnungDe : formValues.bezeichnungDe_new,
      bezeichnungFr : formValues.bezeichnungFr_new,
      bezeichnungIt : formValues.bezeichnungIt_new,
      textDe        : formValues.textDe_new,
      textFr        : formValues.textFr_new,
      textIt        : formValues.textIt_new,
    });
    this.backendService.createDeaktivierungsGrund(grund)
      .subscribe({
        next: () => {
          this.reset();
          this.reloadEntries.emit();
        },
        error: error => {
          this.showAlert();
          console.error(error);
        }
      });
  }

  protected reset() {
    this.newGrundForm.set(this.generateForm());
  }

  private showAlert() {
    Swal.fire({
      text              : this.translateService.instant('admin.deaktivierungsgrund.save.error'),
      icon              : 'error',
      buttonsStyling    : true,
      confirmButtonText : this.translateService.instant('global.ok')
    });
  }
}
